import React from 'react';
import List from '@mui/joy/List';

export default function SidebarList({children} : {children: React.ReactNode}) {
    return (
        <List
			sx={{
				'--ListItem-radius': '8px',
				'--List-gap': '4px',
				'--List-nestedInsetStart': '40px',
			}}
        >{ children }</List>
    );
}
